/** Legacy links look like "/#card-123" or "/card-details/123"; map them to the new routes. */
export function resolveLink(link: string | null | undefined): string | null {
  if (!link) return null
  const match = link.match(/card-(\d+)/)
  if (match) return `/cards/${match[1]}`
  if (link.startsWith('/')) return link
  return null
}
